export default "__VITE_ASSET__BdLHvOQQ__"